export enum LicenseState {
  UNASSIGNED = 'unassigned',
  REQUESTING = 'requesting',
  ACTIVATED = 'activated',
  REVOKED = 'revoked'
}

export enum PaymentStatus {
  UNPAID = 'unpaid',
  PAID = 'paid',
  CANCELLED = 'cancelled'
}

export enum PaymentStatusLabel {
  unpaid = '未払い',
  paid = '支払い済み',
  cancelled = 'キャンセル済み'
}